import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "../../lib/appconst";

interface PoTrackingState extends ListState<any> {}
class PoTrackingModule extends ListModule<PoTrackingState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
  };
  actions = {
    async getAll(context: ActionContext<PoTrackingState, any>, payload: any) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Po/GetAllPoTracking", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
  };
  mutations = {
    setCurrentPage(state: PoTrackingState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: PoTrackingState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const poTrackingModule = new PoTrackingModule();
export default poTrackingModule;
